import React, { useEffect, useState } from "react";

const EmailModal = ({ onClose, onSubmit, emailloader }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    try {
      const parsedDetails = JSON.parse(localStorage.getItem('userdetails'));
      if (parsedDetails?.email) setEmail(parsedDetails.email);
    } catch (_) {}
  }, []);

  const handleChange = (e) => {
    
    setEmail(e.target.value);
  };

  const handleSubmit = () => {
    if (email.trim()) {
      onSubmit(email);
    }
  };

  return (
    <div className="fixed inset-0 backdrop-blur-sm border border-black flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-lg font-bold text-black mb-4">Enter your details</h2>
        <div>
          <div className="mb-4">
            <label htmlFor="email" className="block text-black text-sm font-medium mb-2">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="w-full px-3 py-2 border rounded-lg"
              onChange={handleChange}
              value={email}
              required
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              className="mr-4 px-4 py-2 bg-sky-300/30 text-black rounded-lg hover:bg-sky-300"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-black text-white rounded-lg"
            >
              {emailloader ? "Loading..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailModal;
